import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { Button, Row, Col, Container, Form as BSForm } from "react-bootstrap";
import { Form } from "react-final-form";
import { connect } from "react-redux";
import * as actions from "../actions";
import { Field } from "storefront/features/shared";
import {
  validateEmail,
  validateRequired,
  composeValidators,
} from "storefront/features/shared/components/field/utils";

class RecoverPassword extends PureComponent {
  state = { errorMsg: "" };

  handleResponsErrors = (error) => {
    this.setState({ errorMsg: error });
  };

  handleSubmitForm = (values) => {
    const { fetchCustomerRecoverRequest } = this.props,
      callback = this.handleResponsErrors;
    fetchCustomerRecoverRequest({ callback, ...values });
  };

  render() {
    return (
      <Container>
        <Row className="justify-content-center my-5">
          <Col className="m-5 text-center col-md-6 col-10">
            <h1>Recover password</h1>
            <p>Please enter your email:</p>
            <Form
              noValidate
              onSubmit={this.handleSubmitForm}
              render={({
                handleSubmit,
                submitting,
                pristine,
                dirtySinceLastSubmit,
              }) => (
                <BSForm onSubmit={handleSubmit}>
                  <BSForm.Group>
                    <Field
                      id="recover-password"
                      name="email"
                      type="email"
                      placeholder="Email"
                      validate={composeValidators(
                        validateEmail,
                        validateRequired
                      )}
                      disabled={submitting}
                    />
                  </BSForm.Group>
                  <BSForm.Group>
                    {this.state.errorMsg && !dirtySinceLastSubmit && (
                      <p
                        id="form-recover-error"
                        className="invalid-feedback d-block"
                      >
                        {this.state.errorMsg}
                      </p>
                    )}
                    <Button
                      id="recover-submit"
                      className="w-100"
                      type="submit"
                      variant="primary"
                      disabled={submitting || pristine}
                    >
                      Recover
                    </Button>
                  </BSForm.Group>
                </BSForm>
              )}
            />
            <p>
              Remember your password?
              <Link to="/account/login" id="recover-account-login">
                {" "}
                Back to login{" "}
              </Link>
            </p>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchCustomerRecoverRequest: (values) => {
    dispatch(actions.fetchCustomerRecoverRequest(values));
  },
});

export default connect(null, mapDispatchToProps)(RecoverPassword);
